import { render, staticRenderFns } from "./TheBeer.vue?vue&type=template&id=ebf9c00e&scoped=true&"
import script from "./TheBeer.vue?vue&type=script&lang=js&"
export * from "./TheBeer.vue?vue&type=script&lang=js&"
import style0 from "./TheBeer.vue?vue&type=style&index=0&id=ebf9c00e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf9c00e",
  null
  
)

export default component.exports